import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { BIO_AUTH_USER_CONST } from 'constant'


const GetBioAuthUser = () => {
    try {
        const data = localStorage.getItem(BIO_AUTH_USER_CONST) || ""
        if (data) {
            return data
        }
        return null
    } catch (e) {
        ResetAuthUser()
        return null
    }
}

const ResetAuthUser = () => {
    localStorage.removeItem(BIO_AUTH_USER_CONST);
}

const initialState = { bioAuthToken: GetBioAuthUser() }

const BiometricSlice = createSlice({
    name: 'BioAuth',
    initialState,
    reducers: {
        SET_BIO_AUTH(state, action: PayloadAction<any>) {
            state.bioAuthToken = action.payload
        },
        RESET_AUTH(state) {
            ResetAuthUser()
            state.bioAuthToken = null
        }
    },
})

export const {  SET_BIO_AUTH } = BiometricSlice.actions
export default BiometricSlice.reducer